import { Component, input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  imports: [MatFormFieldModule, MatSelectModule, FormsModule, ReactiveFormsModule, MatInputModule],
})
export class DropdownComponent {
  public options = input.required<{ label: string; value: string }[]>();
  public placeholder = input<string>('Option auswählen');
  public control = input.required<FormControl<string | null>>();
  public errorMsg = input.required<string>();
  public label = input.required<string>();
}
